import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { AppliRoleIcon } from '@apps/auth/domain/models/back/entity';

@Component({
    selector: 'aa-entity-icon-appli',
    templateUrl: './entity-icon-appli.component.html',
    styleUrls: [
        './entity-icon-appli.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EntityIconAppliComponent
{
    @Input() appliRoleIcons: AppliRoleIcon[];
}
